module.exports = __webpack_public_path__ + "static/media/DepartureFlight.18405e40.svg";